import axios from "axios";
import { useRouter } from "next/router";
import React, { useRef, useEffect, useState } from "react";

import { SetLayout } from "../../SetLayout";

import Component from "./Component";

const Container = (props: any) => {
    const { worksheet } = props;
    const { query } = useRouter();
    const { worksheet_id = "", teacher_id: teacherPhNo = "" } = query;

    const getData = useRef(() => null);

    const [hw, setHw] = useState({});

    const dumpEvent = (event_name: string, event_body: any) => {
        axios
            .post(
                `${
                    process.env.NEXT_PUBLIC_MONOLITH_ENDPOINT || ""
                }/prod/sg/proxyAnalyticsEvent`,
                {
                    data: {
                        event_name,
                        properties: event_body,
                        plugins: ["mixpanel"],
                    },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            )
            .then(() => {
                console.log("dumping mixpanel event " + event_name);
            })
            .catch(() => {
                console.log("analytics is not supported");
            });
    };

    const emitEvent = async (eventName: string) => {
        const teacher_params: any = {};
        if (/^\d+$/.test(String(teacherPhNo))) {
            teacher_params["teacher_phone_number"] = Number(teacherPhNo);
        } else {
            teacher_params["teacher_id"] = teacherPhNo;
        }
        const eventParams = {
            course_referrer_id: teacherPhNo,
            log_event_with_teacher_params: true,
            landing_on: "opened_on_web",
            worksheet_id,
            ...teacher_params,
        };
        if (typeof window !== "undefined") {
            const { mobile: current_user_phone_number } = JSON.parse(
                localStorage.getItem("student") || "{}",
            );
            if (current_user_phone_number) {
                eventParams["current_user_phone_number"] =
                    current_user_phone_number;
            }
            dumpEvent(eventName, eventParams);
        }
    };

    getData.current = () => {
        if (!("blocks" in worksheet) || !worksheet.blocks.length) {
            alert("no questions found");
            return null;
        }
        const { questionsWithType, total_questions } =
            getWorksheetHwParsed(worksheet);
        setHw({
            ...worksheet,
            worksheet_id: worksheet_id,
            total_questions,
            questions_with_type: questionsWithType,
        });
        emitEvent("worksheet_opened");
        return null;
    };

    const handleDownload = () => {
        emitEvent("worksheet_preview_download_clicked");
        window.open(
            "https://play.google.com/store/apps/details?id=ai.homework.app.ncert.cbse.maths.science",
            "_ blank",
        );
    };

    useEffect(() => {
        if (getData.current) getData.current();
        if (typeof document != "undefined")
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
    }, []);

    useEffect(() => {
        if (props.stopGlobalBackgroundSound) props.stopGlobalBackgroundSound();
        return () => {
            if (props.stopGlobalBackgroundSound)
                props.stopGlobalBackgroundSound();
        };
    });

    return (
        <div className="set-layout-container">
            <div className="set-layout-view">
                <Component hw={hw} onDownload={handleDownload} {...props} />
            </div>
        </div>
    );
};

export default Container;

function getWorksheetHwParsed(worksheetHw: any) {
    const questionsWithType = [];
    let total_questions = 0;
    let total_attempted = 0;
    for (const block of worksheetHw.blocks) {
        if (
            !["image", "text", "mcq", "case_study", "subjective"].includes(
                block.type,
            )
        )
            continue;
        const data = block.data[block.type];
        const submission = block.submission;

        if (block.type === "text") {
            questionsWithType.push({
                type: block.type.toUpperCase(),
                question_id: block.id,
                text: data,
            });
        }
        if (block.type === "image") {
            questionsWithType.push({
                type: block.type.toUpperCase(),
                question_id: block.id,
                image: data,
            });
        }
        if (block.type === "mcq") {
            total_questions++;
            if (submission?.attempted) {
                total_attempted++;
            }
            questionsWithType.push({
                viewed: submission?.viewed,
                attempted: submission?.attempted,
                correct: submission?.correct,
                corrected: submission?.corrected,
                question_id: block.id,
                option_selected: submission?.option_selected || "-1",
                type: submission?.type || block.type.toUpperCase(),
                index: block.data.index - 1,
                answer_images: submission?.answer_images,
                sub_questions: [],
                question_data: {
                    options: data.options,
                    tags: block.tags,
                    multitags: [],
                    multitags_content_conf: {
                        book: [],
                        chapter: [],
                        topic: [],
                        question: [],
                    },
                    sub_topic_name: "",
                    text: data.text,
                    type: block.type.toUpperCase(),
                    option_count: data.options.length,
                    correct_option: data.correct_option,
                    active: true,
                    // book_id: "",
                    // chapter_id: "",
                    question_id: block.id,
                    // create_datetime: "",
                    sub_questions: [],
                    multitags_conf: {},
                    solution: data.solution,
                },
            });
        }

        if (block.type === "case_study") {
            const index = block.data.index - 1;
            const sub_questions = [];
            total_questions++;
            let attemptedSubQues = 0;
            for (const child of block.children) {
                const data = child.data[child.type];
                const childSubmissions = submission?.sub_questions?.filter(
                    (sub: any) => sub.question_id === child.id,
                );
                let childSubmission: any = {};
                if (childSubmissions?.length) {
                    childSubmission = childSubmissions[0];
                }
                if ((childSubmission.option_selected || "-1") !== "-1") {
                    attemptedSubQues++;
                }

                sub_questions.push({
                    order: child.order,
                    options: data.options,
                    tags: child.tags,
                    text: data.text,
                    option_count: data.options.length,
                    correct_option: data.correct_option,
                    // marks: 1,
                    option_selected: childSubmission.option_selected || "-1",
                    type: childSubmission.type || child.type.toUpperCase(),
                    viewed: childSubmission.viewed || false,
                    attempted: childSubmission.attempted || false,
                    correct: childSubmission.correct || false,
                    question_id: child.id,
                    solution: data.solution,
                });
            }

            if (attemptedSubQues === block.children.length) {
                total_attempted++;
            }

            questionsWithType.push({
                viewed: submission?.viewed,
                attempted: submission?.attempted,
                correct: submission?.correct,
                corrected: submission?.corrected,
                question_id: block.id,
                type: submission?.type || block.type.toUpperCase(),
                sub_questions,
                index: index,
                answer_images: [],
                question_data: {
                    options: [],
                    tags: data.tags,
                    multitags: [],
                    multitags_content_conf: {
                        book: [],
                        chapter: [],
                        topic: [],
                        question: [],
                    },
                    question_id: block.id,
                    text: data.text,
                    type: submission?.type || block.type.toUpperCase(),
                    // book_id: "",
                    // chapter_id: "",
                    sub_questions,
                    // marks: 5,
                    active: true,
                    option_count: 0,
                    correct_option: 0,
                    create_datetime: "",
                    sub_topic_name: "",
                    multitags_conf: {},
                    solution: data.solution,
                },
            });
        }

        if (block.type === "subjective") {
            total_questions++;
            if (submission?.attempted) {
                total_attempted++;
            }
            questionsWithType.push({
                viewed: submission?.viewed,
                attempted: submission?.attempted,
                correct: submission?.correct,
                corrected: submission?.corrected,
                question_id: block.id,
                answer_images: submission?.answer_images,
                type: submission?.type || block.type.toUpperCase(),
                index: block.data.index - 1,
                sub_questions: [],
                question_data: {
                    options: [],
                    tags: [],
                    multitags: [],
                    multitags_content_conf: {
                        book: [],
                        chapter: [],
                        topic: [],
                        question: [],
                    },
                    sub_topic_name: "",
                    text: data.text,
                    type: submission?.type || block.type.toUpperCase(),
                    option_count: 0,
                    correct_option: -1,
                    active: true,
                    // book_id: "",
                    // chapter_id: "",
                    question_id: block.id,
                    // create_datetime: "",
                    sub_questions: [],
                    multitags_conf: {},
                    solution: data.solution,
                },
            });
        }
    }
    return { questionsWithType, total_questions, total_attempted };
}
